import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { arrowUpArrowDownSvg } from '../assets/images';

type Props = {
  items: {
    title: string;
    onClick: () => void;
  }[];
};

const LiveClassesOrderByDropdown = (props: Props) => {
  const __ = useTranslation().t;
  return (
    <Dropdown className="oejr-orderby-dropdown">
      <Dropdown.Toggle as={CustomDropdown}>
        <span>{__('orderBy')}</span>
        <img src={arrowUpArrowDownSvg} alt="Arrow Up Arrow Down" />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {props.items.map((item, key) => (
          <Dropdown.Item key={key} onClick={item.onClick}>
            {item.title}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

type CustomToggleProps = {
  children?: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};

const CustomDropdown = React.forwardRef(
  (props: CustomToggleProps, ref: React.Ref<HTMLAnchorElement>) => (
    <a
      className="cursor-pointer"
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        props.onClick && props.onClick(e);
      }}
    >
      {props.children}
    </a>
  ),
);

export default LiveClassesOrderByDropdown;
